import { usePageMeta } from "../hooks/usePageMeta";
import { PageHero } from "../components/PageHero";
import { ContattiSection } from "../components/home/ContattiSection";
import { Reveal } from "../components/Reveal";
import { ZONES } from "../data/site";
import { useContents } from "../hooks/useContents";

export default function Contatti() {
  const c = useContents();
  const zones = c("zones", ZONES.join(", ")).split(",").map((z) => z.trim()).filter(Boolean);
  usePageMeta(
    "Contatti e Preventivi | Costruzioni Ciosko — Impresa Edile Veneto",
    "Contatta Costruzioni Ciosko per un preventivo: opere murarie, ristrutturazioni, cartongesso, finiture e manutenzioni edili in Veneto. Scrivici via email o WhatsApp."
  );
  return (
    <>
      <PageHero
        overline="Contatti"
        lines={["Parliamo del tuo progetto"]}
        description="Chiamaci, scrivici o compila il modulo: valuteremo insieme la soluzione più adatta alle tue esigenze."
      />
      <ContattiSection number="" compact />
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-10">
          <Reveal>
            <p className="overline-label flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-forest-mid" aria-hidden="true" /> Dove operiamo
            </p>
            <h2 className="h-display text-2xl sm:text-3xl mt-5 text-white">Area operativa: Veneto</h2>
            <p className="text-cement leading-relaxed mt-4 max-w-2xl text-[15px]">
              Lavoriamo in tutto il Veneto, con particolare attenzione alla provincia di Venezia e alle zone limitrofe.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-wrap gap-2.5" data-testid="zone-chips">
              {zones.map((z) => (
                <span key={z} className="border border-steel bg-card px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-metal/80">
                  {z}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
